import type { ReactNode } from "react";
import { useAuthConfig } from "@/app/auth";
import { NotFound } from "@/routes/Placeholder";

/** 只给开发、预览环境的页面：正式环境（没有环境标记）按未知路径处理，配置还没读到时先不渲染（D179）。 */
export function DevOnly({ children }: { children: ReactNode }) {
  const { data, isPending } = useAuthConfig();
  if (isPending) return null;
  return data?.env_label ? <>{children}</> : <NotFound />;
}
